/**
 * @desc test
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(params: API.tms.test.test.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/test/test`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
